module.exports = __webpack_public_path__ + "static/media/bold.b0901080.svg";